module.exports = __webpack_public_path__ + "static/together_bg01_object-3641a5617eb3182726d498c997d00b71.png";